<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex>
        <v-tabs color="transparent" v-model="active" slider-color="secondary">
          <v-tab ripple>Drugs</v-tab>
          <v-tab ripple>Drug Groups</v-tab>
          <v-tab ripple>Lab Tests</v-tab>
          <v-tab ripple>Procedures</v-tab>

          <v-tab-item>
            <drugs/>
          </v-tab-item>

          <v-tab-item>
            <drug-groups/>
          </v-tab-item>

          <v-tab-item>
            <lab-tests/>
          </v-tab-item>

          <v-tab-item>
            <procedures/>
          </v-tab-item>
        </v-tabs>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Drugs from "./drugs.vue";
import DrugGroups from "./drug_groups.vue";
import LabTests from "./tests.vue";
import Procedures from "./procedures.vue";
export default {
  middleware: "admin",
  components: {
    Drugs,
    DrugGroups,
    LabTests,
    Procedures
  },
  data() {
    return {
      active: null
    };
  }
};
</script>

<style scoped>
</style>